module.exports = __webpack_public_path__ + "static/img/ico-user.daef9b4.png";